import { faChevronDown, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useState } from 'react';
import useCollapse from 'react-collapsed';
import { useSearchParams } from 'react-router-dom';
import './CollapseList.scss';
import SubGroup from './SubGroup';


type Props = {
    data?
    onMainGroupClick?: (item) => void;
    onSubGroupClick?: (item) => void;
    onItemMpClick?: (item) => void;
    setOpenModal?: (value: boolean) => void
    iframeInfo?: boolean;
}

const MainGroup:React.FC<Props> = (props) => {
  const [searchParams, setSearchParams] = useSearchParams();


  const [isExpanded, setIsExpanded] = useState(String(props.data.MainGroupId) === searchParams.get('group_id'));

  useEffect(() => {
    setIsExpanded(String(props.data.MainGroupId) === searchParams.get('group_id'));
  }, [searchParams.get('group_id')]);

  function handleOnClick() {
    setIsExpanded(!isExpanded);
  }

  const config={
    isExpanded: isExpanded,
    expandStyles: {
      height: '100%'
    },
    duration: 0,
  };
    
  const { getCollapseProps, getToggleProps } = useCollapse(config);

  return (
    <div className="collapse-list">
      <div className="item">
        <div className="collapse-item" {...getToggleProps({onClick: handleOnClick})}>
          <FontAwesomeIcon icon={isExpanded ? faChevronDown : faChevronRight}/>
          <div>{props.data.MainGroupName}</div> 
        </div>
        {
          props.iframeInfo && (
            <span className="iframe-info-btn" onClick={() => props.onMainGroupClick!(props.data)}>i</span>
          )
        }
      </div>
      {props.data.SubGroups.map((subGroup, index) => {  
        return (
          <div {...getCollapseProps()} key={index}>
            <SubGroup iframeInfo={props.iframeInfo} data={subGroup} onSubGroupClick={props.onSubGroupClick} onItemMpClick={props.onItemMpClick} />
          </div>
        );
      })}
    </div>
  );
};

export default MainGroup;